"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_query_1 = require("react-query");
var api_service_1 = require("../../../api/api_service");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var table_data_1 = require("../../../constants/table_data");
var array_helpers_1 = require("../../../utils/array_helpers");
var fe_services_1 = require("../fe_services");
var menu_constants_1 = require("../../../menuList/menu_constants");
var NewFEApproval = function (_a) {
    var searchValue = _a.searchValue, selectedCities = _a.selectedCities, CurrentPagelimit = _a.CurrentPagelimit, isFilterButton = _a.isFilterButton;
    var feManagementFeatures = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.feManagement);
    var _b = React.useState(undefined), newFeApprovalData = _b[0], setNewFeApprovalData = _b[1];
    var _c = React.useState(0), totalCount = _c[0], setTotalCount = _c[1];
    var _d = React.useState(), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = React.useState(1), pageCount = _e[0], setpageCount = _e[1];
    var _f = React.useState(0), totalPageCount = _f[0], setTotalPageCount = _f[1];
    var fetchNewFeApprovalFE = function (endPoint, payLoad, domain) {
        (0, fe_services_1.fetchFEList)(endPoint, payLoad, domain)
            .then(function (response) {
            var pageSize = CurrentPagelimit
                ? parseInt(CurrentPagelimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setErrorMessage("");
            setTotalPageCount(count);
            setNewFeApprovalData(response.result);
            setTotalCount(response.count);
        })
            .catch(function (err) {
            setErrorMessage(err);
            setNewFeApprovalData([]);
        });
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var refetch = (0, react_query_1.useQuery)(['new-fe-pending-approval', pageCount], function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = (0, array_helpers_1.createPayloadFEForApprovalPending)([appConstants_1.FE_USER_TYPES.levelOne], searchValue, selectedCities);
        payload.page = currentPage;
        payload.size = CurrentPagelimit
            ? parseInt(CurrentPagelimit.value.toString())
            : 50;
        fetchNewFeApprovalFE(api_service_1.api_service.api_urls.FE_LIST, payload, process.env.VENDOR_BASE_URL);
    }).refetch;
    var fetchTableColumns = function () {
        var tableColumns = table_data_1.default.NEW_FE_APPROVALCOLUMNS;
        if (feManagementFeatures[menu_constants_1.FEATURE_CONSTANTS.fe_billing_details]) {
            tableColumns = __spreadArray(__spreadArray([], table_data_1.default.NEW_FE_APPROVALCOLUMNS, true), table_data_1.default.BILLING_COLUMNS, true);
        }
        return tableColumns;
    };
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isFilterButton]);
    return (React.createElement("div", { className: "unclickablerow custom-pagination-table " },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: fetchTableColumns(), rows: newFeApprovalData && newFeApprovalData, errorMessage: errorMessage, pagination: false }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: newFeApprovalData === null || newFeApprovalData === void 0 ? void 0 : newFeApprovalData.length, currentPageLimits: CurrentPagelimit === null || CurrentPagelimit === void 0 ? void 0 : CurrentPagelimit.value })));
};
exports.default = NewFEApproval;
